/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */
import CalendarIcon from 'aurora-images/Calendar.svg';
const styles = theme => ({
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
  },
  contractDurationIfo: {
    background: '#F8F8F8',
    width: '100%',
    border: '1px solid #8C9099',
    marginBottom: '1em',
  },
  adgmBlackText: {
    color: theme.palette.primary.adgmBlack,
  },
  dangerText: {},
  textGray: {
    color: '#8C9099',
    fontWeight: '500',
  },
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  headsubtitle: {
    marginLeft: 'auto',
    fontSize: '12px',
    fontWeight: '500',
  },
  modal_container: {
    '& h1': {
      marginBottom: '18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& img': {
        cursor: 'pointer',
      },

      '& button': {
        background: 'none',
        padding: 0,
      },
    },
  },
  router_link: {
    textDecoration: 'none',
    color: theme.palette.secondary.main,
  },
  strongText: {
    fontSize: '18px',
    fontWeight: '600',
  },
  textADGMPrimary: {
    color: '#D2374F',
  },
  textGrayLight: {
    color: '#8C9099',
  },
  initiateserviceSect: {
    borderBottom: '1px solid #EBEEF3',
    marginBottom: '16px',
    fontSize: '12px',
    '& p': {
      fontSize: '12px',
    },
    '& $Title': {
      fontSize: '14px',
    },
    '&:last-child': {
      borderBottom: '0',
      marginBottom: '0',
    },
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '9px',
    '& img': {
      display: 'none',
    },
  },
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
    // overflow: 'hidden',
  },
  innerCardGrid: {
    padding: '12px 16px',
  },
  horizontalradio: {
    flexDirection: 'row',
    color: '#190B28',
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
    '& svg': {
      height: '28px',
      width: '28px',
    },
    '& span': {
      fontSize: '14px',
    },
  },
  formControl: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '16px',
    '& + $formControl': {
      paddingTop: '15px',
    },
  },
  unitinputControl: {
    '& > p': {
      display: 'block',
      marginBottom: '6px',
      fontWeight: '500',
      fontSize: '12px',
      '& span': {
        // color: '#D2374F',
        fontSize: '18px',
      },
    },
    '& input': {
      padding: '17px 16px',
      fontSize: '12px',
      '&:valid:focus + fieldset': {
        borderColor: '#342D3D',
        borderWidth: '1px',
      },
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
  },
  btns: {
    marginBottom: '16px',
    padding: '16px 22px',
    fontSize: '1rem',
    borderRadius: '10px',
    height: '60px',
    width: '227px',
  },
  outlineBlackBtn: {
    border: '1px solid' + theme.palette.primary.acscent,
    color: theme.palette.primary.acscent,
    '&:hover': {
      opacity: '0.7',
    },
  },
  hide: {
    display: 'none',
  },
  submitBtn: {
    background: theme.palette.primary.main,
    fontSize: '16px',
    color: '#fff',
    height: '60px',
    minWidth: '151px',
    textTransform: 'none',
    borderRadius: '10px',
    '&:hover': {
      background: '#b62e43',
    },
  },
  occupantsGridsectFrame: {
    borderBottom: '1px solid #EBEEF3',
    display: 'flex',
    alignItems: 'flex-start',
  },
  occupantsGridsect: {
    padding: '14px 10px',
    margin: '0 -20px',
    color: '#190B28',
    '& $name': { color: '#342D3D', fontWeight: '600', fontSize: '16px' },
    '& h6': {
      color: '#565960',
      fontSize: '14px',
    },
    '& $griditem': {
      padding: '0 20px',
      '&:first-child': {
        marginBottom: '16px',
      },
      '&:last-child': {
        border: '0',
      },
    },
  },
  removeItemlink: {
    flexShrink: '0',
    marginTop: '37px',
  },
  name: {},
  griditem: {},
  brokerEmailarea: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingTop: '11px',
    '& a': {
      display: 'flex',
      alignItems: 'center',
      color: '#342D3D',
      marginRight: '20px',
    },
    '& figure': {
      width: '24px',
      height: '24px',
      borderRadius: '100rem',
      background: '#FFEBEE',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 4px 0',
      color: '#D2374F',
    },
  },
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    '& $ownerAvatarimg': {
      marginRight: '16px',
      height: '64px',
      width: '64px',
      background: '#EBEEF3',
    },
  },
  ownerAvatarimg: {},
  addBrokerbtnHolder: {
    padding: '6px 0',
  },
  addBrokersBtn: {
    height: '36px',
    width: 'auto',
    minWidth: '167px',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'none',
    border: '1.36111px solid #342D3D',
    borderRadius: '10px',
    marginBottom: '0',
    '& svg': {
      marginRight: '4px',
      width: '12px',
    },
  },
  modalpaper: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '10px',
    fontSize: '16px',
  },
  modal: {
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    maxWidth: '797px',
    position: 'relative',
    marginTop: '50px',
    padding: '30px 45px',
    '& $Title': {
      marginBottom: '20px',
    },
    '& $crossIconimg': {
      position: 'absolute',
      right: '24px',
      top: '31px',
    },
    '& $modaltitlehead': {
      display: 'block',
      '& img': {
        display: 'none',
      },
    },
    '& $brokerEmailarea': {
      '& a': {
        marginBottom: '8px',
      },
    },
  },
  modaltitlehead: {},
  crossIconimg: {},
  calendarTextfield: {
    '& input': {
      backgroundImage: `url(${CalendarIcon})`,
      backgroundPosition: '95% center',
      backgroundRepeat: 'no-repeat',
      '&::-webkit-calendar-picker-indicator': {
        opacity: '0',
      },
    },
  },
  searchHolder: {
    display: 'flex',
    marginBottom: '26px',
  },
  autocompleteHolder: {
    width: '100%',
    background: theme.palette.primary.grey,
    '& > div > div': {
      height: '55px',
    },
    '& input': {
      padding: '17px 16px',
      fontSize: '12px',
      '&:focus + div + fieldset': {
        borderColor: '#D2374F !important',
        borderWidth: '1px !important',
      },
    },
    '& fieldset': {
      border: '1px solid #CED1D6',
      borderRadius: '10px',
    },
    '& img': {
      marginRight: '10px',
    },
  },
  searchbtn: {
    minWidth: '126px',
    height: '55px',
    marginLeft: '12px',
    display: 'none',
    border: '1px solid #342D3D',
    borderRadius: '10px',
    color: '#342D3D',
    textTransform: 'none',
    fontSize: '16px',
    '& svg': {
      marginRight: theme.spacing(1),
    },
    '&:hover': {
      border: '1px solid #342D3D',
      color: '#342D3D',
      background: '#fff',
    },
  },
  propertyContentArea: {
    maxHeight: '25vh',
    overflow: 'auto',
    marginTop: '24px',
    marginBottom: '20px',
    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '0 0 12px 0',
    },
    '&::-webkit-scrollbar': {
      width: '11px',
      background: '#F8F8F8',
      borderRadius: '0 0 12px 0',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '50rem',
    },
  },
  listItemHolder: {
    display: 'flex',
    alignItems: 'center',
    padding: '19px 0',
    fontSize: '14px',
    '& p': {
      fontSize: '14px',
    },
  },
  contentDetail: {
    flex: '1 1 auto',
    padding: '11px',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    background: '#fff',
    alignItems: 'center',
    position: 'relative',
    '& $gridItem': {
      padding: '0 10px 0 25px',
      borderLeft: '1px solid #EBEEF3',
      '&:first-child': {
        padding: '0',
        borderLeft: '0',
      },
    },
    '& $subTitle': {
      color: '#565960',
      marginBottom: '2px',
    },
  },
  subTitle: {},
  gridItem: {},
  checkedcontentDetail: {
    background: '#EFFBFC',
  },
  inputCheckbox: {
    color: '#342D3D',
    marginRight: '7px',
    flexShrink: '0',
    '& svg': {
      height: '30px',
      width: '30px',
    },
    '& input:checked + svg': {
      color: '#1FCACC',
    },
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
  },
  greenChip: {
    background: '#1C999B',
    color: '#fff',
  },
  initibadges: {
    fontSize: '12px',
    position: 'absolute',
    top: '-19px',
    height: '19px',
    borderRadius: '10px 10px 0 0',
    minWidth: '72px',
    left: '10px',
  },
  brokerModalFilter: {
    marginBottom: '24px',
    '& label': {
      marginLeft: '0',
      marginRight: '8px',
      '& span': {
        padding: '12px 14px',
        boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
        borderRadius: '10px',
        border: '1px solid #1FCACC',
        background: '#fff',
        fontSize: '14px',
        fontWeight: '500',
        '&:first-child': {
          display: 'none',
        },
      },
    },
    '& $inputChecked': {
      '& span': {
        background: '#1C999B',
        color: '#fff',
      },
    },
  },
  inputChecked: {},
  agreementDetailsinnerCard: {
    color: '#342D3D',
    '& $innerframe': {
      borderTop: '1px solid #EBEEF3',
      padding: '20px 0',
      '&:first-child': {
        paddingTop: '0',
        borderTop: '0',
      },
    },
    '& $graysubtitle': {
      color: '#565960',
      marginBottom: '6px',
    },
    '& $CheckboxHolder': {
      '& label': {
        '& span': {
          fontSize: '18px',
        },
      },
      '& input:checked + svg': {
        color: '#1FCACC',
      },
      '& input:checked + div': {
        color: theme.palette.primary.main,
      },
    },
    '& $CheckboxcheckedHolder': {
      display: 'flex',
      // gridTemplateColumns: '1fr 1fr',
      flexDirection: 'column',
    },
  },
  innerframe: {},
  CheckboxHolder: {},
  graysubtitle: {},
  CheckboxcheckedHolder: {},
  '@media (min-width: 768px)': {
    addBrokersBtn: {
      height: '60px',
      fontSize: '1rem',
      minWidth: '227px',
      borderRadius: '13.6111px',
      '& svg': {
        marginRight: '7px',
        width: '13px',
      },
    },
    searchbtn: {
      minWidth: '216px',
      display: 'inline-block',
    },
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
    headsubtitle: {
      fontSize: '16px',
      fontWeight: '400',
    },
    initiateserviceSect: {
      fontSize: '16px',
      '& p': {
        fontSize: '16px',
      },
      '& $Title': {
        fontSize: '20px',
      },
    },
    unitinputControl: {
      '& > p': {
        fontSize: '1rem',
      },
      '& input': {
        fontSize: '1rem',
      },
    },
    occupantsGridsect: {
      '& $griditem': {
        borderRight: '1px solid #EBEEF3',
        '&:first-child': {
          marginBottom: '0',
        },
      },
    },
  },
  '@media (min-width: 992px)': {
    formControl: {
      gridTemplateColumns: '1fr 1fr',
    },
    initiateservicedtaile: {
      gridTemplateColumns: '61px auto',
      '& img': {
        display: 'block',
      },
    },
    innerCardGrid: {
      padding: '24px',
    },
    horizontalradio: {
      '& span': {
        fontSize: '1rem',
      },
    },
    occupantsGridsectFrame: {
      alignItems: 'center',
    },
    removeItemlink: {
      marginTop: '0',
    },
  },
  '@media (max-width: 767px)': {
    titleHead: {
      flexWrap: 'wrap',
    },
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
    modal: {
      top: '0',
      left: '0',
      transform: 'translate(0)',
      maxWidth: '100%',
      borderRadius: '0',
      height: '100%',
      padding: '25px 15px 100px',
      marginTop: '0',
      '& $Title': {
        fontSize: '16px',
        marginBottom: '0',
      },
      '& $crossIconimg': {
        display: 'none',
      },
      '& $modaltitlehead': {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '3px solid #EBEEF3',
        marginBottom: '20px',
        '& img': {
          marginRight: '13px',
          display: 'inline-block',
        },
      },
    },
    submitBtnholder: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      background: '#fff',
      padding: '16px',
      borderTop: '3px solid #EBEEF3',
      zIndex: '1021',
      '& button': {
        width: '100%',
        margin: '0',
        height: '48px',
      },
    },
    propertyContentArea: {
      maxHeight: '49vh',
    },
    agreementDetailsinnerCard: {
      '& $CheckboxHolder': {
        '& label': {
          '& span': {
            fontSize: '14px',
          },
          [theme.breakpoints.down('md')]: {
            justifyContent: 'space-between',
            paddingLeft: '16px',
            '& span:first-child': {
              order: 1,
            },
          },
        },
      },
      '& $graysubtitle': {
        fontSize: '14px',
      },
    },
  },
  alignGridItemsToBottom: {
    alignSelf: 'end',
  },
  informationMessage: {
    paddingBottom: '0px',
    paddingTop: '0px',
    marginBottom: '16px',
    marginTop: '16px',
  },
  selectBox: {
    verticalAlign: 'middle',
    justifyContent: 'center',
    padding: '14px 8px',
    '& p': {
      fontSize: '14px',
    },
  },

  formControlContract: {
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '0.8fr 1.2fr 1fr 1fr',
    },
  },
  adgmAlert: {
    width: '100%',
  },
});

export default styles;
